import { useEffect, useState } from 'react'
import { isAccountDisabledSignalled, subscribeToAccountDisabled } from '../utils/disabledAccountSignal'

// Set by callSecureAPI the first time any request comes back with code: 'USER_DISABLED'. No
// separate status fetch: every route already refuses these accounts, so the first failed call is
// the signal. Resets on reload, so re-enabling takes effect immediately.
export const useIsUserDisabled = () => {
    const [isDisabled, setIsDisabled] = useState(isAccountDisabledSignalled)

    useEffect(() => subscribeToAccountDisabled(() => setIsDisabled(true)), [])

    return isDisabled
}
